awardCalculation.classy.controller({
    name: 'TuitionController',
    inject: ['$scope', 'PutService', 'CalculationService', 'BinFactory', 'DateService'],
    init: function()
    {
    	this.$.isArchive = this.BinFactory.isArchive();
        this.$.DateService = this.DateService;
    },
    tuitionPut: function(scope, instance, form)
    {
        var parent = this;
        instance.options.factor = .3;
        return this.PutService.putApplicant().then(function() {
            parent.CalculationService.reCalc(); 
            instance.stop(1)
        });
    }
});
